module.exports = __webpack_public_path__ + "assets/img/al1.33a0b347.png";